///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const CalendarIcon = ({
  height,
  title = messages.calendar.defaultMessage,
  width,
  fill
}) => (
  <svg
    aria-labelledby="calendar-icon"
    height={height}
    viewBox="0 0 16 16"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id="calendar-icon">{title}</title>
    <path
      d="M13.3333333 2h-.6666666V.66666667h-1.3333334V2H4.66666667V.66666667H3.33333333V2h-.66666666c-.73333334 0-1.33333334.6-1.33333334 1.33333333V14c0 .7333333.6 1.3333333 1.33333334 1.3333333H13.3333333c.7333334 0 1.3333334-.6 1.3333334-1.3333333V3.33333333C14.6666667 2.6 14.0666667 2 13.3333333 2zm0 12H2.66666667V5.33333333H13.3333333V14z"
      fill={fill}
    />
  </svg>
);
export default CalendarIcon;
